import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-555b57db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "jumbotrons" }
const _hoisted_2 = {
  align: "center",
  class: "jumbotron"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "title" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Error", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" The textbox can not be empty ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Error", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" The provided list contains invalid proxies ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { state, startCheck } from '@/composables/proxy-checker';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const onClose = () => {
  state.error = false;
};

const onStartCheck = () => {
  // console.log('click');

  if (state.input === '') {
    state.error = true;
    // console.log('error');
  } else {
    state.error = false;
    // console.log('---');
    startCheck();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("textarea", {
        id: "proxy_list",
        class: "form-control",
        rows: "10",
        placeholder: "0.0.0.0:1234\n127.0.0.1:3434\nlocalhost:8080\n",
        style: {"margin-top":"0px","margin-bottom":"0px","height":"286px","min-height":"100px"},
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).input) = $event))
      }, null, 512), [
        [_vModelText, _unref(state).input]
      ]),
      _hoisted_4,
      (_unref(state).error && _unref(state).input === '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            style: {"cursor":"pointer"},
            onClick: onClose
          }, _hoisted_7))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: "alert alert-danger",
        onClick: onClose,
        style: {"cursor":"pointer"}
      }, _hoisted_10, 512), [
        [_vShow, _unref(state).error]
      ]),
      _createElementVNode("button", {
        class: "btn",
        onClick: onStartCheck
      }, "Check proxies"),
      _hoisted_11,
      _hoisted_12
    ])
  ]))
}
}

})